import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { createTheme } from "@mui/material/styles";
import { base } from "./base";
var palette = _object_spread_props(_object_spread({}, base.palette), {
    mode: "light",
    primary: {
        light: "#D6EFF9",
        main: "#269AE0",
        dark: "#157DBB"
    }
});
export var light = createTheme(_object_spread_props(_object_spread({}, base), {
    palette: palette,
    components: _object_spread_props(_object_spread({}, base.components), {
        MuiAppBar: {
            defaultProps: {
                color: "default"
            },
            styleOverrides: {
                root: {
                    height: 64,
                    "@media print": {
                        display: "none"
                    }
                },
                colorDefault: {
                    backgroundColor: palette.primary.main
                }
            }
        }
    })
}));
